import { hasRole } from "@/auth/helpers";
import { useUser } from "@/auth/useUser";
import { useWalletCreditTypeQuery } from "@/graphql/queries/walletCreditType.graphql.types";
import { useWalletCreditTypesQuery } from "@/graphql/queries/walletCreditTypes.graphql.types";
import { MEDICAL_DIRECTOR } from "@/types";

export function useWalletCreditTypes() {
  const { medspa, user } = useUser();
  const isMdOrGfe = hasRole(user, [MEDICAL_DIRECTOR]);

  const { data: creditTypeData } = useWalletCreditTypesQuery({
    variables: { medspaId: medspa },
    skip: !medspa || isMdOrGfe,
  });

  return creditTypeData?.walletCreditType || [];
}

export function useWalletCreditType(walletCreditType?: string) {
  const { data: walletCreditTypeData } = useWalletCreditTypeQuery({
    variables: { id: walletCreditType },
    skip: !walletCreditType,
  });

  return walletCreditTypeData?.walletCreditTypeByPk;
}
